import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "souq_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

async function unwrap(promise) {
  try {
    const res = await promise;
    return res.data;
  } catch (e) {
    const msg = formatError(e.response?.data?.detail, e.message);
    const err = new Error(msg);
    err.status = e.response?.status;
    throw err;
  }
}

export const api = {
  get: (path, params) => unwrap(client.get(path, { params })),
  post: (path, body) => unwrap(client.post(path, body)),
  put: (path, body) => unwrap(client.put(path, body)),
  patch: (path, body) => unwrap(client.patch(path, body)),
  del: (path) => unwrap(client.delete(path)),
};
